export const mapOptions = {
    panControl: false,
    mapTypeControl: false,
    scrollwheel: false,
    fullscreenControl: false,

    styles: [
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#64646b',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#1c1c1e',
                },
            ],
        },
        {
            featureType: 'administrative.country',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#3a3a40',
                },
            ],
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#3a3a40',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.icon',
            stylers: [
                {
                    color: '#1e1e20',
                },
            ],
        },
        {
            featureType: 'administrative.province',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#3a3a40',
                },
            ],
        },
        {
            featureType: 'administrative.province',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#1c1c1e',
                },
            ],
        },
        {
            featureType: 'landscape.natural',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#18181a',
                },
            ],
        },
        {
            featureType: 'landscape.natural',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#18181a',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.place_of_worship',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#242426',
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#1b1b1d',
                },
                {
                    visibility: 'off',
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.local',
            stylers: [
                {
                    color: '#242426',
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#2d2d30',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#64646b',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#020203',
                },
            ],
        },
        {
            featureType: 'transit.station',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.station.airport',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#18181a',
                },
            ],
        },
        {
            featureType: 'transit.station.airport',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#020203',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#64646b',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#020203',
                },
            ],
        },
    ],
};
